import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from '_constants/theme';
const { colors, devices, fontSizes, spaces } = theme;

const StyledHorizontalTable = styled.div`
  display: none;
  flex-direction: column;
  @media ${devices.tablet} {
    display: flex;
  }
`;
const StyledColumnTable = styled.div`
  margin-bottom: ${spaces.regular}px;
`;
const StyledRowTable = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${colors.gray[100]};
  padding: ${spaces.regular}px;
  &:nth-child(odd) {
    background: ${colors.gray[50]};
  }
  &:first-child {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
  &:last-child {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
  &:first-child > div:last-child {
    font-weight: 500;
  }
`;
const StyledRowLeftTable = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.regular}px;
  line-height: 19px;
  text-transform: uppercase;
  color: ${colors.gray[500]};
`;
const StyledRowRightTable = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.regular}px;
  line-height: 19px;
  text-align: right;
  color: ${colors.gray[700]};
`;
const HorizontalTable = ({ columns = [], rows = [], loading = false }) => {
  return (
    <StyledHorizontalTable>
      {rows.map((row, idx) => (
        <StyledColumnTable key={idx}>
          {columns.map(({ dataIndex, title, render }) => (
            <StyledRowTable key={`${dataIndex}-${idx}`}>
              <StyledRowLeftTable>{title}</StyledRowLeftTable>
              <StyledRowRightTable>
                {render ? render(row, idx) : row[dataIndex]}
              </StyledRowRightTable>
            </StyledRowTable>
          ))}
        </StyledColumnTable>
      ))}
    </StyledHorizontalTable>
  );
};

HorizontalTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      dataIndex: PropTypes.string.isRequired,
      title: PropTypes.node.isRequired,
      width: PropTypes.string,
      render: PropTypes.func,
    })
  ),
  rows: PropTypes.array,
  loading: PropTypes.bool,
};

export default HorizontalTable;
